export default [
  {
    path: '/upa',
    component: () => import('@/pages/Upa/Index.vue'),
  },
]
